import { MessageSquare, ThumbsUp } from "lucide-react";
import { Link } from "react-router-dom";
import { formatRoundsTime, type RoundThreadSummary } from "@/lib/rounds";

export function ThreadRow({ thread }: { thread: RoundThreadSummary }) {
  return (
    <article className="pb-rounds-thread-row">
      <div className="pb-rounds-thread-row__chips">
        <Link to={`/board/rounds/c/${encodeURIComponent(thread.communitySlug)}`}>
          {thread.communityName}
        </Link>
        {thread.isAnonymisedCase ? <span>Anonymised case</span> : null}
        {thread.status === "locked" ? <span>Locked</span> : null}
      </div>
      <h2>
        <Link to={`/board/rounds/t/${encodeURIComponent(thread.id)}`}>
          {thread.title}
        </Link>
      </h2>
      <p>{thread.excerpt}</p>
      {thread.tags.length ? (
        <div className="pb-rounds-tags" aria-label="Thread tags">
          {thread.tags.map((tag) => <span key={tag}>{tag}</span>)}
        </div>
      ) : null}
      <footer>
        <span className="pb-rounds-author">
          <strong>{thread.author.display}</strong>
          <small>@{thread.author.handle}</small>
          <RoleChip role={thread.author.role} />
          {thread.author.userId ? (
            <Link className="pb-rounds-message-link" to={`/board/messages/new?handle=${encodeURIComponent(thread.author.handle)}`}>
              <MessageSquare size={11} aria-hidden="true" />Message
            </Link>
          ) : null}
        </span>
        <span><MessageSquare size={13} aria-hidden="true" />{thread.replyCount} replies</span>
        <span><ThumbsUp size={13} aria-hidden="true" />{Math.max(0, thread.score)} helpful</span>
        <time dateTime={thread.lastActivityAt}>{formatRoundsTime(thread.lastActivityAt)}</time>
      </footer>
    </article>
  );
}

export function RoleChip({ role }: { role: string }) {
  const label = role === "specialist" ? "Specialist" : role === "gp" ? "GP" : "PulseBoard";
  return <span className="pb-rounds-role" data-role={role}>{label}</span>;
}
